/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'date-legend': {
    width: 32,
    height: 16,
    viewBox: '0 0 2048 1024',
    data: '<path pid="0" d="M585.75 0H1949.72a98.304 98.304 0 0198.304 102.4l-487.424 819.2a102.4 102.4 0 01-98.304 102.4H96.279A100.352 100.352 0 01.023 921.6l487.424-819.2A98.304 98.304 0 01585.75 0z" _fill="#2F9BFF"/>'
  }
})
